/*
 * Item shop reskin (Oct 2026) runtime.
 * Plain ES5-compatible script, no dependencies. Every module no-ops when its
 * markup is absent, so this file is safe to load on every layout.
 */
(function () {
  'use strict';

  var YIS = (window.YIS = window.YIS || {});
  var TZ = 'America/New_York';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesktop() {
    return !window.matchMedia || window.matchMedia('(min-width: 901px)').matches;
  }

  // Text from Shopify's `t` filter (and other escaped Liquid) arrives HTML-escaped
  // ("Couldn&#39;t"); decode it before using it as text or a cart property.
  function decode(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  /* ======================= time (Eastern, DST aware) ======================= */

  var etParts;
  try {
    etParts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch (e) {
    etParts = null;
  }

  // Offset in ms between Eastern wall-clock time and UTC at instant ts.
  function etOffset(ts) {
    if (!etParts) return -5 * 3600000;
    var p = {};
    etParts.formatToParts(new Date(ts)).forEach(function (x) {
      p[x.type] = x.value;
    });
    var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return asUTC - Math.floor(ts / 1000) * 1000;
  }

  // "YYYY-MM-DD HH:MM" (Eastern wall clock) -> UTC epoch ms. NaN if unparseable
  // or not a real date/time (2026-02-30, 24:00, 12:60), so a typo shows zeroes.
  function parseEastern(str) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2})(?::(\d{2}))?)?\s*$/.exec(str || '');
    if (!m) return NaN;
    var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
    var check = new Date(wall);
    if (check.getUTCMonth() !== +m[2] - 1 || check.getUTCDate() !== +m[3] || check.getUTCHours() !== +(m[4] || 0) || check.getUTCMinutes() !== +(m[5] || 0)) return NaN;
    var first = wall - etOffset(wall);
    return wall - etOffset(first);
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Long form (clock) mirrors the mock's dur(): "Xd Xh Xm" / HH:MM:SS. Short form
  // (rows, hero, collection pages): "Xd Xh 05m 09s", or "Xh 05m 09s" under a day.
  function formatRemaining(ms, mode) {
    if (!(ms > 0)) ms = 0;
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var x = s % 60;
    if (mode === 'short') {
      return (d > 0 ? d + 'd ' : '') + h + 'h ' + pad(m) + 'm ' + pad(x) + 's';
    } else if (d > 0) {
      return d + 'd ' + h + 'h ' + m + 'm';
    }
    return pad(h) + ':' + pad(m) + ':' + pad(x);
  }

  function tickCountdowns() {
    var now = Date.now();
    qsa('[data-yis-countdown]').forEach(function (el) {
      if (el._yisTarget === undefined) el._yisTarget = parseEastern(el.getAttribute('data-yis-countdown'));
      var target = el._yisTarget;
      var text = isNaN(target) ? formatRemaining(0, el.getAttribute('data-mode')) : formatRemaining(target - now, el.getAttribute('data-mode'));
      if (el.textContent !== text) el.textContent = text;
    });
    // LEAVING SOON pills (snippets/yis-leaving-flag) read Leaving Today in the
    // last 24 hours before the target.
    qsa('[data-yis-leaving-flag]').forEach(function (el) {
      if (el._yisTarget === undefined) el._yisTarget = parseEastern(el.getAttribute('data-yis-leaving-flag'));
      var left = el._yisTarget - now;
      var text = left > 0 && left <= 86400000 ? el.getAttribute('data-today') : el.getAttribute('data-soon');
      if (text && el.textContent !== text) el.textContent = text;
    });
    // "Leaving Today" badges: visible only in the last 24 hours before the target.
    qsa('[data-yis-leaving]').forEach(function (el) {
      if (el._yisTarget === undefined) el._yisTarget = parseEastern(el.getAttribute('data-yis-leaving'));
      var left = el._yisTarget - now;
      el.hidden = !(left > 0 && left <= 86400000);
    });
  }

  /* ============================== toast ============================== */

  YIS.toast = function (msg) {
    var t = qs('[data-yis-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'yis-toast';
      t.setAttribute('data-yis-toast', '');
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(YIS.toast._t);
    YIS.toast._t = setTimeout(function () {
      t.classList.remove('is-on');
    }, 2200);
  };

  var inits = [];

  /* ========================= reduced motion ========================= */

  // CSS (yis.css) switches off animations and transitions; this covers the
  // motion CSS can't reach: decorative autoplaying loops (animated product
  // shots on tiles and product pages). They stop on their first frame. Videos
  // people start themselves (the trailer, with controls) are left alone.
  // Registered at load, in the capture phase, so it also catches play()
  // calls from inline section scripts.
  document.addEventListener(
    'play',
    function (e) {
      var v = e.target;
      if (!reducedMotion() || !v || v.tagName !== 'VIDEO' || !v.loop || !v.muted || v.controls) return;
      v.pause();
      v.removeAttribute('autoplay');
      if (v.preload === 'none') v.preload = 'auto';
      try {
        v.currentTime = 0;
      } catch (err) {}
    },
    true
  );

  /* ============================== trailer ============================== */

  function initTrailers() {
    qsa('[data-yis-trailer]').forEach(function (wrap) {
      var btn = qs('[data-yis-trailer-play]', wrap);
      var tpl = qs('template[data-yis-trailer-media]', wrap);
      if (!btn || !tpl || wrap._yis) return;
      wrap._yis = true;
      btn.addEventListener('click', function () {
        var frag = tpl.content ? tpl.content.cloneNode(true) : null;
        if (!frag) return;
        wrap.appendChild(frag);
        btn.remove();
        var v = qs('video', wrap);
        if (v) {
          v.setAttribute('autoplay', '');
          var p = v.play && v.play();
          if (p && p.catch) p.catch(function () {});
          v.focus && v.focus();
        }
      });
    });
  }
  inits.push(initTrailers);

  /* ============================ drawers ============================ */

  var openDrawer = null;
  var lastFocus = null;

  function drawerEl(name) {
    return qs('[data-yis-drawer="' + name + '"]');
  }

  function setOpeners(name, open) {
    qsa('[data-yis-open="' + name + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function closeDrawers(restoreFocus) {
    qsa('[data-yis-drawer]').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      d.inert = true;
      d.setAttribute('inert', '');
      setOpeners(d.getAttribute('data-yis-drawer'), false);
    });
    var scrim = qs('[data-yis-scrim]');
    if (scrim) scrim.hidden = true;
    if (!qs('dialog.yis-modal[open]')) document.body.classList.remove('yis-lock');
    openDrawer = null;
    if (restoreFocus !== false && lastFocus && lastFocus.isConnected && lastFocus.focus) lastFocus.focus();
  }

  // returnTo: where focus goes when the drawer closes (default: what has focus
  // now). Quick add passes the card's + button, because the chip or modal
  // button that triggered the add is removed straight away.
  function showDrawer(name, returnTo) {
    var d = drawerEl(name);
    if (!d) return false;
    var switching = openDrawer && openDrawer !== name;
    if (switching) closeDrawers(false);
    if (!openDrawer && !switching) lastFocus = returnTo || document.activeElement;
    d.inert = false;
    d.removeAttribute('inert');
    d.setAttribute('aria-hidden', 'false');
    d.classList.add('is-open');
    setOpeners(name, true);
    var scrim = qs('[data-yis-scrim]');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('yis-lock');
    openDrawer = name;
    setTimeout(function () {
      var f = qs('[data-yis-close]', d);
      if (f) f.focus({ preventScroll: true });
    }, 60);
    return true;
  }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-yis-open]');
      if (opener) {
        var name = opener.getAttribute('data-yis-open');
        if (drawerEl(name)) {
          e.preventDefault();
          if (openDrawer === name) closeDrawers();
          else if (name === 'cart') YIS.cart.open();
          else showDrawer(name);
        }
        return;
      }
      var closer = e.target.closest('[data-yis-close], [data-yis-scrim]');
      if (closer && openDrawer) {
        // The empty-cart button is a real link home; only intercept it when
        // we are already on the homepage.
        if (closer.tagName === 'A' && closer.pathname !== window.location.pathname) return;
        e.preventDefault();
        closeDrawers();
      }
    });

    // Keep Tab inside the open drawer.
    document.addEventListener('keydown', function (e) {
      if (!openDrawer || e.key !== 'Tab') return;
      var d = drawerEl(openDrawer);
      var f = qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', d).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }
  inits.push(initDrawers);

  /* ============================== cart ============================== */

  var routes = (function () {
    var r = { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' };
    var el = qs('script[data-cart-routes]');
    if (el) {
      try {
        var j = JSON.parse(el.textContent);
        r.cart = j.cartUrl || r.cart;
        r.add = j.cartAddUrl || r.add;
        r.change = j.cartChangeUrl || r.change;
      } catch (e) {}
    }
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) r.root = window.Shopify.routes.root;
    return r;
  })();

  var SECTION = 'yis-cart-drawer';

  function applyCartHTML(html) {
    var body = qs('[data-yis-cart-body]');
    if (!body || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var next = qs('[data-yis-cart-body]', tmp);
    if (!next) return;
    // The close button and line controls live inside the re-rendered body:
    // keep keyboard focus on the same control (same line + action), else Close.
    var had = document.activeElement;
    var focusIn = had && body.contains(had);
    var key = focusIn && had.getAttribute('data-yis-line');
    var act = focusIn && had.getAttribute('data-yis-act');
    body.replaceWith(next);
    syncHeader(next);
    if (focusIn) {
      var f = null;
      if (key) {
        f = qsa('[data-yis-line]', next).filter(function (b) {
          return b.getAttribute('data-yis-line') === key && b.getAttribute('data-yis-act') === act && !b.disabled;
        })[0];
      }
      f = f || qs('[data-yis-close]', next);
      if (f) f.focus({ preventScroll: true });
    }
  }

  function syncHeader(body) {
    body = body || qs('[data-yis-cart-body]');
    if (!body) return;
    var count = body.getAttribute('data-count');
    var total = body.getAttribute('data-total');
    var changed = false;
    qsa('[data-yis-cart-count]').forEach(function (el) {
      if (el.textContent !== count) changed = true;
      el.textContent = count;
    });
    qsa('[data-yis-cart-total]').forEach(function (el) {
      if (el.textContent !== total) changed = true;
      el.textContent = total;
    });
    qsa('[data-yis-wallet]').forEach(function (el) {
      var label = (el.getAttribute('aria-label') || '').split(',')[0];
      el.setAttribute('aria-label', label + ', ' + body.getAttribute('data-label'));
      // Bump only when the cart actually changed, not on every re-render.
      if (!changed) return;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function showCartError(msg) {
    if (!msg) return;
    var e = qs('[data-yis-cart-error]');
    if (e) {
      e.textContent = msg;
      e.hidden = false;
    } else {
      YIS.toast(msg);
    }
  }

  function postJSON(url, data) {
    return fetch(url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      // X-YIS marks our own requests so the fetch watcher below skips them.
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-YIS': '1' },
      body: JSON.stringify(data),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j.status && j.status !== 200)) {
          // Only Shopify's own description is shown as-is; otherwise callers
          // fall back to the theme's translated cart error.
          var desc = j.description || j.message;
          var err = new Error(desc || 'cart ' + r.status);
          err.fromServer = !!desc;
          throw err;
        }
        return j;
      });
    });
  }

  function refresh() {
    return fetch(routes.root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        applyCartHTML(j[SECTION]);
      });
  }

  var busy = false;
  // Lines are addressed by item key, not position, so a stale drawer can't
  // change the wrong item. applyCartHTML keeps focus on the same control.
  function change(key, qty) {
    if (busy) return;
    busy = true;
    var d = drawerEl('cart');
    if (d) d.setAttribute('aria-busy', 'true');
    function done() {
      busy = false;
      if (d) d.removeAttribute('aria-busy');
    }
    postJSON(routes.change, { id: key, quantity: qty, sections: SECTION })
      .then(function (j) {
        if (j.sections) applyCartHTML(j.sections[SECTION]);
        else return refresh();
      })
      .catch(function (err) {
        var msg = err && err.fromServer ? err.message : window.theme && theme.strings && theme.strings.cartError;
        // Even if the refresh fails too (offline), show the error and unlock.
        return refresh()
          .catch(function () {})
          .then(function () {
            if (msg) showCartError(msg);
          });
      })
      .then(done, done);
  }

  function addVariant(id) {
    return postJSON(routes.add, { items: [{ id: +id, quantity: 1 }], sections: SECTION }).then(function (j) {
      if (j.sections) applyCartHTML(j.sections[SECTION]);
      else return refresh();
    });
  }

  YIS.cart = {
    refresh: refresh,
    open: function (doRefresh) {
      if (!doRefresh) {
        // Show at once, then catch up with changes made elsewhere (other tabs, other scripts).
        showDrawer('cart');
        return refresh().catch(function () {});
      }
      return refresh().then(
        function () {
          showDrawer('cart');
        },
        function () {
          window.location.href = routes.cart;
        }
      );
    },
    // Called by theme.js after a successful AJAX add-to-cart. That add went
    // through fetch, so drop the watcher's own refresh for it.
    added: function () {
      clearTimeout(pending);
      lbPageAdded();
      return YIS.cart.open(true);
    },
    // Card + button / quick view: add lines, re-render the drawer, open it.
    // returnTo gets focus back when the drawer closes.
    add: function (items, returnTo) {
      return postJSON(routes.add, { items: items, sections: SECTION })
        .then(function (j) {
          if (j.sections) applyCartHTML(j.sections[SECTION]);
          else return refresh();
        })
        .then(function () {
          showDrawer('cart', returnTo);
        });
    },
    // Lookbook quick view: same add, but the drawer stays shut (the re-render
    // still updates the cart count), so shoppers keep browsing.
    addQuiet: function (items) {
      return postJSON(routes.add, { items: items, sections: SECTION }).then(function (j) {
        if (j.sections) applyCartHTML(j.sections[SECTION]);
        else return refresh();
      });
    },
  };

  // Other scripts change the cart without telling us: the Single snippets
  // (fetch and jQuery XHR, e.g. /cart/add.json on album pages) and apps.
  // Refresh the drawer + header pill after a successful cart change.
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var pending;
  function cartChangedElsewhere() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      refresh().catch(function () {});
    }, 150);
  }
  // Attribute- or note-only updates (e.g. a fraud app tagging the cart) don't
  // change what the drawer shows.
  function changesLines(url, body) {
    if (!/\/cart\/update/.test(url) || typeof body !== 'string' || !body) return true;
    return /updates/.test(body);
  }

  function initCart() {
    if (!drawerEl('cart')) {
      YIS.cart = null;
      return;
    }
    document.addEventListener('click', function (e) {
      var lineBtn = e.target.closest('[data-yis-line]');
      if (lineBtn) {
        e.preventDefault();
        change(lineBtn.getAttribute('data-yis-line'), +lineBtn.getAttribute('data-qty'));
        return;
      }
      var up = e.target.closest('[data-yis-upsell]');
      if (up) {
        e.preventDefault();
        if (busy) return;
        busy = true;
        up.disabled = true;
        addVariant(up.getAttribute('data-yis-upsell'))
          .catch(function (err) {
            up.disabled = false;
            showCartError(err && err.fromServer ? err.message : window.theme && theme.strings && theme.strings.cartError);
          })
          .then(function () {
            busy = false;
          });
      }
    });
    // The page may come from bfcache with a stale count.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh().catch(function () {});
    });
    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var res = nativeFetch.apply(this, arguments);
        var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
        var h = init && init.headers;
        // X-YIS marks yis's own requests, which re-render the drawer themselves.
        var own = h && (typeof h.get === 'function' ? h.get('X-YIS') : h['X-YIS']);
        if (!own && CART_CHANGE.test(url) && changesLines(url, init && init.body)) {
          res.then(function (r) {
            if (r.ok) cartChangedElsewhere();
          }, function () {});
        }
        return res;
      };
    }
    if (window.XMLHttpRequest) {
      var xOpen = XMLHttpRequest.prototype.open;
      var xSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this._yisUrl = String(url || '');
        return xOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        var x = this;
        if (CART_CHANGE.test(x._yisUrl || '') && changesLines(x._yisUrl, body)) {
          x.addEventListener('loadend', function () {
            if (x.status >= 200 && x.status < 300) cartChangedElsewhere();
          });
        }
        return xSend.apply(this, arguments);
      };
    }
  }
  inits.push(initCart);

  /* ============================ Esc ============================ */
  // Esc closes the open drawer (menu / cart) or the card's size picker.
  // (The desktop shortcuts and key bar were removed, user 2026-10-16.)
  function initEsc() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || e.isComposing || e.keyCode === 229) return;
      var picker = qs('[data-yis-pick]');
      if (openDrawer) closeDrawers();
      else if (picker) YIS.closePicker(true);
    });
  }
  inits.push(initEsc);

  /* ========================= card + button ========================= */
  // Theme settings > Item shop > Card + button (desktop): "quick_add" adds to
  // the cart from the card (size chips on the card for one-option products,
  // the modal for several options); "modal" always opens the quick view.
  // Both read sections/yis-quick-view, fetched through the Section Rendering
  // API and cached per product (prefetched when the card is hovered).
  var qvCache = {};

  function qvFetch(url) {
    var u = url.split('?')[0];
    if (!qvCache[u]) {
      qvCache[u] = fetch(u + '?section_id=yis-quick-view', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('quick view ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var root = qs('[data-yis-qv]', tmp);
          var data = JSON.parse(qs('[data-yis-qv-json]', root).textContent);
          // Translations and the shipping-timeline snippet come escaped. The
          // product page adds the decoded timeline (read from an attribute), so
          // decode here too or the same variant would become a second cart line.
          ['addLabel', 'soldOutLabel', 'unavailableLabel', 'selectLabel', 'chooseLabel', 'closeLabel', 'errorLabel'].forEach(function (k) {
            data[k] = decode(data[k]);
          });
          data.variants.forEach(function (v) {
            v.timeline = decode(v.timeline);
          });
          return { root: root, data: data };
        })
        .catch(function (err) {
          delete qvCache[u];
          throw err;
        });
    }
    return qvCache[u];
  }

  function lineFor(v, qty) {
    var item = { id: v.id, quantity: qty || 1 };
    if (v.timeline) item.properties = { '_Shipping Timeline': v.timeline };
    return item;
  }

  function addLines(items, returnTo) {
    if (YIS.cart && YIS.cart.add) return YIS.cart.add(items, returnTo);
    // No slideout cart (e.g. on the cart page): add, then go to the cart.
    return postJSON(routes.add, { items: items }).then(function () {
      window.location.href = routes.cart;
    });
  }

  function setBusy(el, on) {
    if (!el) return;
    el.classList.toggle('is-busy', on);
    if (on) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
  }

  /* --- size chips on the card (quick add, one option) --- */
  var pickerOpener = null;

  YIS.closePicker = function (restoreFocus) {
    var p = qs('[data-yis-pick]');
    if (!p) return;
    p.remove();
    if (restoreFocus && pickerOpener) pickerOpener.focus({ preventScroll: true });
    pickerOpener = null;
  };

  function showPicker(tile, btn, d) {
    YIS.closePicker(false);
    pickerOpener = btn;
    var box = document.createElement('div');
    box.className = 'yis-tile__pick';
    box.setAttribute('data-yis-pick', '');
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', d.data.chooseLabel);
    var head = document.createElement('div');
    head.className = 'yis-tile__pick-h';
    head.textContent = d.data.selectLabel;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'yis-tile__pick-x';
    x.setAttribute('aria-label', d.data.closeLabel);
    x.innerHTML = '<span class="yis-ico yis-ico--close" aria-hidden="true"></span>';
    x.addEventListener('click', function () {
      YIS.closePicker(true);
    });
    head.appendChild(x);
    box.appendChild(head);
    var row = document.createElement('div');
    row.className = 'yis-tile__pick-row';
    d.data.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = v.options[0];
      if (!v.available) {
        b.disabled = true;
        b.classList.add('is-out');
        b.setAttribute('aria-label', v.options[0] + ', ' + d.data.soldOutLabel);
      }
      b.addEventListener('click', function () {
        setBusy(b, true);
        qsa('button', row).forEach(function (o) {
          o.disabled = true;
        });
        addLines([lineFor(v, 1)], btn).then(
          function () {
            YIS.closePicker(false);
          },
          function (err) {
            YIS.closePicker(true);
            YIS.toast(err && err.fromServer ? err.message : d.data.errorLabel);
          }
        );
      });
      row.appendChild(b);
    });
    box.appendChild(row);
    tile.appendChild(box);
    var first = qs('.yis-tile__pick-row button:not([disabled])', box) || x;
    first.focus({ preventScroll: true });
  }

  /* --- product modal (quick view) --- */
  // opts.stay (lookbook): add without opening the cart drawer, then close the
  // modal and show opts.added as a toast; the page never scrolls meanwhile.
  // Lookbook tracking hooks: opts.line(item, v) may return a promise of the
  // line to add (the _lookbook stamp), opts.onAdded(v, qty) runs after a
  // successful add, opts.onDetails() when "View full details" is followed.
  function openModal(d, opener, opts) {
    opts = opts || {};
    var data = d.data;
    var dlg = document.createElement('dialog');
    dlg.className = 'yis-modal';
    dlg.setAttribute('aria-label', data.title);
    dlg.innerHTML =
      '<button type="button" class="yis-pillbtn yis-modal__x" data-yis-modal-close aria-label="' +
      data.closeLabel.replace(/"/g, '&quot;') +
      '"><span class="yis-ico yis-ico--close" aria-hidden="true"></span></button>';
    // The content scrolls inside .yis-modal__body, so the X stays in the corner.
    var body = document.createElement('div');
    body.className = 'yis-modal__body';
    var root = d.root.cloneNode(true);
    body.appendChild(root);
    dlg.appendChild(body);
    document.body.appendChild(dlg);

    var sel = [];
    var qty = 1;
    var groups = qsa('[data-yis-qv-opt]', root);
    if (!data.requireSelection) {
      var first = data.variants.filter(function (v) {
        return v.available;
      })[0] || data.variants[0];
      sel = first.options.slice();
    }
    var addBtn = qs('[data-yis-qv-add]', root);
    var priceEl = qs('[data-yis-qv-price]', root);
    var hint = qs('[data-yis-qv-hint]', root);
    var tl = qs('[data-yis-qv-timeline]', root);
    var img = qs('[data-yis-qv-img]', root);
    var thumbs = qsa('[data-yis-qv-thumb]', root);
    var qtyEl = qs('[data-yis-qv-qty]', root);

    // Main image swap (thumb tap or a variant with its own photo); the tile
    // with the same URL lights up. The new photo goes into a fresh <img>,
    // swapped in once loaded: changing src on the copy parsed from the quick
    // view HTML leaves it blank (Chrome), and this way there's no empty flash.
    var wantSrc = '';
    function showImage(src) {
      if (!img || !src) return;
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-yis-qv-thumb') === src;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (wantSrc === src) return;
      wantSrc = src;
      var next = document.createElement('img');
      next.alt = img.alt;
      next.setAttribute('data-yis-qv-img', '');
      next.onload = function () {
        if (wantSrc !== src || !img.parentNode) return;
        img.parentNode.replaceChild(next, img);
        img = next;
      };
      next.src = src;
    }
    // Same caps as the product page (titol_max_1 hides quantity, titol_max_4 caps at 4).
    var maxQty = data.maxQty > 0 ? data.maxQty : 99;
    var qtyBox = qs('.yis-qv__qty', root);
    if (qtyBox && maxQty === 1) qtyBox.hidden = true;

    function current() {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return sel[i] === o;
        });
      })[0];
    }

    function update() {
      groups.forEach(function (g) {
        var i = +g.getAttribute('data-yis-qv-opt');
        qsa('button', g).forEach(function (b) {
          var val = b.getAttribute('data-value');
          var on = sel[i] === val;
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.classList.toggle('is-on', on);
          // Greyed when no available variant has this value with the other picks.
          var ok = data.variants.some(function (v) {
            if (!v.available || v.options[i] !== val) return false;
            return v.options.every(function (o, k) {
              return k === i || !sel[k] || sel[k] === o;
            });
          });
          b.classList.toggle('is-out', !ok);
        });
      });
      var v = current();
      if (v) {
        priceEl.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
        if (v.image) showImage(v.image);
      }
      tl.hidden = !(v && v.timeline);
      tl.textContent = v && v.timeline ? v.timeline : '';
      if (!v) {
        // Every option picked but no such variant: "Unavailable", not "Select".
        var picked = groups.length && sel.filter(Boolean).length === groups.length;
        addBtn.disabled = true;
        addBtn.textContent = picked && data.unavailableLabel ? data.unavailableLabel : data.selectLabel;
      } else if (!v.available) {
        addBtn.disabled = true;
        addBtn.textContent = data.soldOutLabel;
      } else {
        addBtn.disabled = false;
        addBtn.textContent = (v.state === 'preorder' && data.preorderLabel ? data.preorderLabel : data.addLabel) + ' · ' + v.price.replace(/<[^>]*>/g, '');
      }
    }

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-yis-qv-thumb]');
      if (thumb) {
        showImage(thumb.getAttribute('data-yis-qv-thumb'));
        return;
      }
      var opt = e.target.closest('[data-yis-qv-opt] button');
      if (opt) {
        var i = +opt.closest('[data-yis-qv-opt]').getAttribute('data-yis-qv-opt');
        sel[i] = opt.getAttribute('data-value');
        hint.textContent = '';
        update();
        return;
      }
      var q = e.target.closest('[data-yis-qv-q]');
      if (q) {
        qty = Math.max(1, Math.min(maxQty, qty + +q.getAttribute('data-yis-qv-q')));
        qtyEl.textContent = qty;
        return;
      }
      if (e.target.closest('.yis-qv__more')) {
        if (opts.onDetails) opts.onDetails();
        return;
      }
      if (e.target.closest('[data-yis-qv-add]')) {
        var v = current();
        if (!v || !v.available) return;
        setBusy(addBtn, true);
        addBtn.disabled = true;
        var quiet = opts.stay && YIS.cart && YIS.cart.addQuiet;
        var n = qty;
        var item = lineFor(v, n);
        Promise.resolve(opts.line ? opts.line(item, v) : item)
          .then(function (line) {
            return quiet ? YIS.cart.addQuiet([line]) : addLines([line], opener);
          })
          .then(
            function () {
              dlg.close();
              if (quiet && opts.added) YIS.toast(opts.added);
              if (opts.onAdded) opts.onAdded(v, n);
            },
            function (err) {
              setBusy(addBtn, false);
              update();
              hint.textContent = err && err.fromServer ? err.message : data.errorLabel;
            }
          );
      }
    });
    // Opening the description shrinks the photo first (phone sheet); if it
    // still runs past the bottom, scroll it into view, keeping its tab showing.
    var desc = qs('[data-yis-qv-desc]', root);
    if (desc) {
      desc.addEventListener('toggle', function () {
        if (!desc.open) return;
        var box = body.getBoundingClientRect();
        var r = desc.getBoundingClientRect();
        var pad = parseFloat(getComputedStyle(body).paddingBottom) || 0;
        var by = Math.min(r.bottom + pad - box.bottom, r.top - box.top - 8);
        if (by > 0) body.scrollBy({ top: by, behavior: 'smooth' });
      });
    }
    // Arrow keys move between the values of one option (radio group).
    root.addEventListener('keydown', function (e) {
      var opt = e.target.closest('[data-yis-qv-opt] button');
      if (!opt || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var all = qsa('button', opt.parentNode);
      var k = all.indexOf(opt) + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1);
      all[(k + all.length) % all.length].focus();
    });
    // A click on the backdrop lands on the <dialog> itself, but so does a click
    // in its own padding: close only when the press started and ended outside
    // the box (a text drag that ends outside doesn't count).
    function outside(e) {
      var r = dlg.getBoundingClientRect();
      return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    }
    var downOutside = false;
    dlg.addEventListener('mousedown', function (e) {
      downOutside = e.target === dlg && outside(e);
    });
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-yis-modal-close]') || (e.target === dlg && downOutside && outside(e))) dlg.close();
      downOutside = false;
    });
    dlg.addEventListener('close', function () {
      dlg.remove();
      if (!qs('dialog.yis-modal[open]') && !openDrawer) document.body.classList.remove('yis-lock');
      if (opener && document.contains(opener) && !openDrawer) opener.focus({ preventScroll: true });
    });

    update();
    document.body.classList.add('yis-lock');
    dlg.showModal();
    var focusEl = qs('[data-yis-qv-opt] button', root) || addBtn;
    focusEl.focus({ preventScroll: true });
  }

  // Delegated from the document: "Also available" tiles arrive after boot.
  function initCardPlus() {
    document.addEventListener('pointerover', function (e) {
      // The + only shows with a mouse on desktop; don't prefetch on touch.
      if ((e.pointerType && e.pointerType !== 'mouse') || !isDesktop()) return;
      var tile = e.target.closest && e.target.closest('.yis-tile');
      var btn = tile && qs('[data-yis-qa]', tile);
      if (btn && !btn.hasAttribute('data-yis-pre')) {
        btn.setAttribute('data-yis-pre', '');
        qvFetch(btn.getAttribute('data-url')).catch(function () {});
      }
    });
    document.addEventListener('click', function (e) {
      var pick = qs('[data-yis-pick]');
      if (pick && !pick.contains(e.target) && !e.target.closest('[data-yis-qa]')) YIS.closePicker(false);
      var btn = e.target.closest('[data-yis-qa]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-busy')) return;
      var tile = btn.closest('.yis-tile');
      var mode = btn.getAttribute('data-yis-qa');
      setBusy(btn, true);
      qvFetch(btn.getAttribute('data-url'))
        .then(function (d) {
          var data = d.data;
          if (mode === 'modal' || data.options.length > 1) {
            setBusy(btn, false);
            openModal(d, btn);
            return;
          }
          if (data.variants.length === 1) {
            return addLines([lineFor(data.variants[0], 1)], btn).then(function () {
              setBusy(btn, false);
            });
          }
          setBusy(btn, false);
          showPicker(tile, btn, d);
        })
        .catch(function (err) {
          setBusy(btn, false);
          if (err && err.fromServer) YIS.toast(err.message);
          // Couldn't load the quick view: fall back to the product page.
          else window.location.href = btn.getAttribute('data-url');
        });
    });
  }
  inits.push(initCardPlus);

  /* ========================= search bar + suggestions ========================= */
  // Header search (desktop): a round button that expands into the search bar.
  function initSearchBar() {
    var form = qs('[data-yis-search-form]');
    if (!form || form._yis) return;
    form._yis = true;
    var input = qs('input[type="search"]', form);
    var toggle = qs('[data-yis-search-toggle]', form);
    var closeBtn = qs('[data-yis-search-close]', form);
    form.classList.add('is-collapsible');

    var lobby = form.closest('.yis-lobby');
    function setOpen(on, focus) {
      form.classList.toggle('is-open', on);
      // Narrower desktops: the brand steps aside while the bar is open (yis.css).
      if (lobby) lobby.classList.toggle('is-searching', on);
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      // The collapsed field is invisible: keep it out of the Tab order.
      input.tabIndex = closeBtn.tabIndex = on ? 0 : -1;
      if (on && focus) input.focus({ preventScroll: true });
      if (!on && YIS.closeSuggest) YIS.closeSuggest(input);
    }
    // A search results page keeps its terms visible in the bar, where there is
    // room for it next to the brand (the page has its own search box too).
    // The markup arrives collapsed; the starting state is set without the
    // open/close animation (.is-instant).
    form.classList.add('is-instant');
    setOpen(!!input.value.trim() && !(window.matchMedia && window.matchMedia('(max-width: 1390px)').matches), false);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        form.classList.remove('is-instant');
      });
    });

    toggle.addEventListener('click', function () {
      if (!form.classList.contains('is-open')) setOpen(true, true);
      else if (input.value.trim()) form.requestSubmit ? form.requestSubmit() : form.submit();
      else setOpen(false);
    });
    closeBtn.addEventListener('click', function () {
      input.value = '';
      setOpen(false);
      toggle.focus();
    });
    form.addEventListener('keydown', function (e) {
      // Esc anywhere in the open bar: the suggestion list closes first (see
      // initSuggest, which stops the event), then the bar.
      var list = document.getElementById(input.getAttribute('aria-controls'));
      if (e.key === 'Escape' && !e.isComposing && !e.defaultPrevented && form.classList.contains('is-open') && !(list && !list.hidden)) {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        setOpen(false);
        toggle.focus();
      }
    });
    // Collapse when focus leaves an empty bar.
    form.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!form.contains(document.activeElement) && !input.value.trim()) setOpen(false);
      }, 0);
    });
  }
  inits.push(initSearchBar);

  // Suggestions (Shopify predictive search) for every [data-yis-suggest] input,
  // rendered by sections/yis-predictive-search. Combobox pattern: arrows move
  // through the options, Enter opens one, Esc closes the list.
  var suggestCache = {};
  var suggestAbort = null;

  function fetchSuggest(q) {
    if (suggestCache[q]) return Promise.resolve(suggestCache[q]);
    if (suggestAbort) suggestAbort.abort();
    suggestAbort = window.AbortController ? new AbortController() : null;
    var url =
      routes.root +
      'search/suggest?q=' +
      encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article&resources[limit]=6' +
      '&resources[options][unavailable_products]=last&section_id=yis-predictive-search';
    return fetch(url, { credentials: 'same-origin', signal: suggestAbort && suggestAbort.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('suggest ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var res = qs('[data-yis-suggest-results]', tmp);
        var out = res ? res.innerHTML : '';
        suggestCache[q] = out;
        return out;
      });
  }

  var suggestClosers = [];
  YIS.closeSuggest = function (input) {
    suggestClosers.forEach(function (c) {
      if (!input || c.input === input) c.close();
    });
  };

  function initSuggest() {
    qsa('[data-yis-suggest]').forEach(function (input) {
      var panel = document.getElementById(input.getAttribute('aria-controls'));
      if (!panel || input._yis) return;
      input._yis = true;
      var timer = null;
      var active = -1;
      var shownFor = '';

      function options() {
        return qsa('[role="option"]', panel);
      }
      function open() {
        if (!panel.innerHTML.trim()) return;
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function close() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        setActive(-1);
      }
      function setActive(i) {
        var opts = options();
        opts.forEach(function (o, k) {
          o.classList.toggle('is-active', k === i);
          o.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        active = i;
        if (i >= 0 && opts[i]) {
          input.setAttribute('aria-activedescendant', opts[i].id);
          opts[i].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }
      function run() {
        var q = input.value.trim();
        if (!q) {
          close();
          panel.innerHTML = '';
          shownFor = '';
          return;
        }
        if (q === shownFor) {
          open();
          return;
        }
        fetchSuggest(q).then(
          function (html) {
            if (input.value.trim() !== q) return;
            shownFor = q;
            panel.innerHTML = html;
            options().forEach(function (o, k) {
              o.id = panel.id + '-' + k;
            });
            setActive(-1);
            if (document.activeElement === input) open();
          },
          function () {}
        );
      }
      suggestClosers.push({ input: input, close: close });

      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(run, 160);
      });
      input.addEventListener('focus', function () {
        if (input.value.trim()) run();
      });
      input.addEventListener('keydown', function (e) {
        if (e.isComposing || e.keyCode === 229) return;
        var opts = options();
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (panel.hidden || !opts.length) return;
          e.preventDefault();
          var i = active + (e.key === 'ArrowDown' ? 1 : -1);
          if (i < -1) i = opts.length - 1;
          if (i >= opts.length) i = -1;
          setActive(i);
        } else if (e.key === 'Enter' && active >= 0 && opts[active] && !panel.hidden) {
          e.preventDefault();
          window.location.href = opts[active].href;
        } else if (e.key === 'Escape' && !panel.hidden) {
          e.preventDefault();
          e.stopPropagation();
          close();
        }
      });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && !panel.contains(e.target) && e.target !== input) close();
      });
    });
  }
  inits.push(initSuggest);

  /* ========================= hero carousel ========================= */

  function initCarousel(hc) {
    var track = qs('[data-yis-hc-track]', hc);
    if (!track || hc._yis) return;
    var bars = qsa('[data-yis-hc-go]', hc);
    var n = track.children.length;
    var dur = +hc.getAttribute('data-interval') || 6500;
    var i = 0;
    var t0 = performance.now();
    var progress = 0;
    var holds = {}; // reasons auto-advance is paused: hover, focus, hidden tab, editor
    var raf = 0;
    var shown = -1;

    function held() {
      for (var k in holds) if (holds[k]) return true;
      return false;
    }

    function paint(p) {
      progress = p;
      bars.forEach(function (b, k) {
        var bar = b.firstElementChild;
        if (bar) bar.style.width = (k < i ? 100 : k === i ? p * 100 : 0) + '%';
        if (shown !== i) b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      shown = i;
    }

    function go(k, smooth) {
      i = (k + n) % n;
      t0 = performance.now();
      track.scrollTo({ left: track.clientWidth * i, behavior: smooth !== false && !reducedMotion() ? 'smooth' : 'auto' });
      paint(0);
      schedule();
    }

    // The frame loop only runs while the carousel is actually advancing.
    function running() {
      return n > 1 && hc.isConnected && !held() && !reducedMotion();
    }
    function tick(ts) {
      raf = 0;
      if (!running()) return;
      var p = Math.min(1, (ts - t0) / dur);
      paint(p);
      if (p >= 1) go(i + 1);
      else schedule();
    }
    function schedule() {
      if (!raf && running()) raf = requestAnimationFrame(tick);
    }
    function hold(reason, on) {
      var was = held();
      holds[reason] = on;
      // Resume from where the bar stopped.
      if (was && !held()) t0 = performance.now() - progress * dur;
      schedule();
    }

    // Hover pause only with the section's "Pause while hovered" setting.
    if (hc.hasAttribute('data-yis-hc-hover-pause')) {
      hc.addEventListener('mouseenter', function () {
        hold('hover', true);
      });
      hc.addEventListener('mouseleave', function () {
        hold('hover', false);
      });
    }
    hc.addEventListener('focusin', function () {
      hold('focus', true);
    });
    hc.addEventListener('focusout', function () {
      hold('focus', false);
    });
    document.addEventListener('visibilitychange', function () {
      hold('hidden', document.hidden);
    });
    hc.addEventListener('click', function (e) {
      var g = e.target.closest('[data-yis-hc-go]');
      var s = e.target.closest('[data-yis-hc-step]');
      if (g) go(+g.getAttribute('data-yis-hc-go'));
      else if (s) go(i + +s.getAttribute('data-yis-hc-step'));
    });
    var st;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var k = Math.round(track.scrollLeft / track.clientWidth);
          if (k !== i) {
            i = k;
            t0 = performance.now();
            paint(0);
            schedule();
          }
        }, 120);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      if (hc.isConnected) track.scrollLeft = track.clientWidth * i;
    });
    // Theme editor: selecting a slide block shows it and holds it there.
    hc._yis = {
      show: function (slide) {
        var k = Array.prototype.indexOf.call(track.children, slide);
        if (k < 0) return;
        holds.editor = true;
        go(k, false);
      },
      release: function () {
        hold('editor', false);
      },
    };
    paint(0);
    schedule();
  }

  function initCarousels() {
    qsa('[data-yis-hc]').forEach(initCarousel);
  }
  inits.push(initCarousels);

  /* =============== rows: jump buttons, dot rail, row art =============== */

  var rowIO = null;
  var jumpClicks = false;

  // Built from every row on the page; run again after the theme editor
  // re-renders the hero (empty jumps/dots) or a row.
  function initRows() {
    var rows = qsa('[data-yis-row]');
    var jumps = qs('[data-yis-jumps]');
    var dots = qs('[data-yis-dots]');
    var bgart = qs('[data-yis-bgart]');
    if (rowIO) rowIO.disconnect();
    if (!rows.length) return;

    function link(row, inner) {
      var a = document.createElement('a');
      a.href = '#' + row.id;
      a.setAttribute('data-jump', row.id);
      a.innerHTML = inner;
      return a;
    }

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    if (jumps) {
      jumps.innerHTML = '';
      rows.forEach(function (r) {
        jumps.appendChild(link(r, esc(r.getAttribute('data-title') || r.id)));
      });
    }
    if (dots) {
      dots.innerHTML = '';
      rows.forEach(function (r, k) {
        var a = link(r, '<span>' + esc(r.getAttribute('data-title') || r.id) + '</span>');
        a.setAttribute('aria-label', r.getAttribute('data-title') || r.id);
        if (k === 0) a.classList.add('is-on');
        dots.appendChild(a);
      });
    }

    if (!jumpClicks) {
      jumpClicks = true;
      document.addEventListener('click', function (e) {
        var a = e.target.closest('[data-jump]');
        if (!a) return;
        var el = document.getElementById(a.getAttribute('data-jump'));
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + el.id);
      });
    }

    var layers = bgart ? qsa('div', bgart) : [];
    var cur = '';
    var flip = 0;
    function setArt(src) {
      if (!layers.length || !src || src === cur || !isDesktop()) return;
      cur = src;
      flip ^= 1;
      layers[flip].style.backgroundImage = 'url("' + src + '")';
      layers[flip].classList.add('is-on');
      layers[flip ^ 1].classList.remove('is-on');
    }
    function artOf(row) {
      var t = qs('[data-yis-art]:not([data-yis-art=""])', row);
      return t && t.getAttribute('data-yis-art');
    }
    setArt(artOf(rows[0]));

    if (!('IntersectionObserver' in window)) return;
    rowIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var id = e.target.id;
          if (dots) {
            qsa('a', dots).forEach(function (a) {
              a.classList.toggle('is-on', a.getAttribute('data-jump') === id);
            });
          }
          setArt(artOf(e.target));
        });
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    rows.forEach(function (r) {
      rowIO.observe(r);
    });
  }
  inits.push(initRows);

  /* ===================== product: option buttons ===================== */

  // Mirrors each variant <select> as a row of buttons. The select stays in the
  // DOM (visually hidden) and remains the source of truth for theme.js, which
  // listens for its change event.
  function initOptionButtons() {
    qsa('.yis-product select.single-option-selector').forEach(function (select, n) {
      var wrap = select.closest('.selector-wrapper') || select.parentNode;
      // theme "Variant swatches" setting already renders buttons for this option
      if (wrap.querySelector('.swatch-container') || select._yis) return;
      select._yis = true;
      var label = wrap.querySelector('label');
      var group = document.createElement('div');
      group.className = 'yis-sizes';
      group.setAttribute('role', 'radiogroup');
      if (label) {
        if (!label.id) label.id = 'YisOptLabel-' + n + '-' + Math.random().toString(36).slice(2, 7);
        group.setAttribute('aria-labelledby', label.id);
        label.classList.add('yis-i-label');
      }

      function build() {
        group.innerHTML = '';
        var stop = false;
        Array.prototype.forEach.call(select.options, function (opt) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.textContent = opt.textContent.trim();
          b.setAttribute('data-value', opt.value);
          var on = opt.value === select.value;
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on && !opt.disabled ? 0 : -1;
          if (on && !opt.disabled) stop = true;
          if (on) b.classList.add('is-on');
          if (opt.disabled) {
            b.disabled = true;
            b.setAttribute('aria-disabled', 'true');
          }
          group.appendChild(b);
        });
        // Checked value disabled (e.g. a sold-out ?variant= link): keep a Tab stop.
        if (!stop) {
          var first = group.querySelector('button:not([disabled])');
          if (first) first.tabIndex = 0;
        }
      }

      function choose(value, focus) {
        if (select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        build();
        if (focus) {
          var b = group.querySelector('[data-value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
          if (b) b.focus();
        }
      }

      group.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        // Rebuilding replaces the buttons: keep focus on the chosen one.
        if (b && !b.disabled) choose(b.getAttribute('data-value'), document.activeElement === b);
      });
      group.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
        e.preventDefault();
        var btns = qsa('button:not([disabled])', group);
        var i = btns.indexOf(document.activeElement);
        var step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
        var next = btns[(i + step + btns.length) % btns.length];
        if (next) choose(next.getAttribute('data-value'), true);
      });
      select.addEventListener('change', build);

      build();
      select.classList.add('yis-sr');
      select.setAttribute('tabindex', '-1');
      select.setAttribute('aria-hidden', 'true');
      wrap.appendChild(group);
    });
  }
  inits.push(initOptionButtons);

  /* ===================== product: quantity stepper ===================== */

  function initQtySteppers() {
    qsa('.yis-product input[data-quantity-input]').forEach(function (input) {
      if (input.closest('.yis-qty')) return;
      var box = document.createElement('div');
      box.className = 'yis-qty';
      var minus = document.createElement('button');
      var plus = document.createElement('button');
      minus.type = plus.type = 'button';
      minus.textContent = '−';
      plus.textContent = '+';
      var str = (window.theme && theme.strings) || {};
      minus.setAttribute('aria-label', str.yisDecrease || 'Decrease quantity');
      plus.setAttribute('aria-label', str.yisIncrease || 'Increase quantity');
      input.parentNode.insertBefore(box, input);
      box.appendChild(minus);
      box.appendChild(input);
      box.appendChild(plus);
      function step(d) {
        var min = +input.min || 1;
        var max = input.max ? +input.max : Infinity;
        var v = Math.max(min, Math.min(max, (parseInt(input.value, 10) || min) + d));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      minus.addEventListener('click', function () {
        step(-1);
      });
      plus.addEventListener('click', function () {
        step(1);
      });
    });
  }
  inits.push(initQtySteppers);

  /* ===================== product gallery (mock "inspect") ===================== */

  // Arrows, dash dots and swipe on the product image. They drive the theme's
  // own thumbnails (under the dots, desktop only), so theme.js keeps handling
  // media switching, variant images, the animated shot and zoom.
  function initGallery() {
    qsa('[data-yis-gal]').forEach(function (nav) {
      var root = nav.closest('.yis-product');
      var group = nav.closest('[data-product-single-media-group]');
      var dots = qs('[data-yis-gal-dots]', nav);
      if (!root || !group || nav._yis) return;
      nav._yis = true;

      function thumbs() {
        return qsa('.product-single__thumbnail', root).filter(function (t) {
          return t.isConnected;
        });
      }

      function current(ts) {
        for (var i = 0; i < ts.length; i++) if (ts[i].classList.contains('active-thumb')) return i;
        return 0;
      }

      function sync() {
        var ts = thumbs();
        nav.hidden = ts.length < 2;
        if (dots.children.length !== ts.length) {
          dots.innerHTML = '';
          ts.forEach(function () {
            dots.appendChild(document.createElement('i'));
          });
        }
        var k = current(ts);
        qsa('i', dots).forEach(function (d, i) {
          d.classList.toggle('is-on', i === k);
        });
      }

      function step(d) {
        var ts = thumbs();
        if (ts.length < 2) return;
        ts[(current(ts) + d + ts.length) % ts.length].click();
      }

      nav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-yis-gal-step]');
        if (b) step(+b.getAttribute('data-yis-gal-step'));
      });

      // Touch: horizontal swipes only; leave 3D models, video controls and
      // fields alone (vertical moves keep scrolling the page).
      var x0 = null;
      var y0 = 0;
      group.addEventListener('touchstart', function (e) {
        var skip = e.target.closest && e.target.closest('model-viewer, video[controls], input, [data-yis-gal-step]');
        x0 = e.touches.length === 1 && !skip ? e.touches[0].clientX : null;
        y0 = e.touches.length === 1 ? e.touches[0].clientY : 0;
      }, { passive: true });
      group.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      });

      // Mouse: click and drag the photo (desktop browsers, any width). The
      // click that ends a drag is swallowed so it doesn't zoom or follow a
      // link, and the browser's own image drag is turned off.
      var mx = null;
      var my = 0;
      var dragged = false;
      group.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || nav.hidden) return;
        var skip = e.target.closest && e.target.closest('model-viewer, video[controls], input, button, a, .product-single__thumbnails');
        if (skip) return;
        mx = e.clientX;
        my = e.clientY;
        dragged = false;
        // Keep receiving the drag when the mouse leaves the photo.
        if (group.setPointerCapture) group.setPointerCapture(e.pointerId);
      });
      group.addEventListener('pointermove', function (e) {
        if (mx !== null && Math.abs(e.clientX - mx) > 6) {
          dragged = true;
          group.classList.add('is-dragging');
        }
      });
      function endDrag(e) {
        if (mx === null) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        mx = null;
        group.classList.remove('is-dragging');
        if (e.type === 'pointerup' && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      }
      group.addEventListener('pointerup', endDrag);
      group.addEventListener('pointercancel', endDrag);
      group.addEventListener('click', function (e) {
        // Only the user's own click after a drag (step() clicks a thumbnail).
        if (!dragged || !e.isTrusted) return;
        dragged = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
      group.addEventListener('dragstart', function (e) {
        if (e.target.tagName === 'IMG') e.preventDefault();
      });

      // theme.js moves .active-thumb on clicks and variant changes; the
      // animated-shot fallback can remove its thumbnail.
      var list = qs('.product-single__thumbnails', root);
      if (list) new MutationObserver(sync).observe(list, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }
  inits.push(initGallery);

  /* ========================= alternate style wipe ========================= */
  // Tiles with the wipe (.yis-tile--alt) show their front image until they
  // scroll into view, then join one shared cycle, so every wipe on the page
  // moves at the same moment. The cycle (yis-alt-wipe, 8s) shows the front
  // image for 0-38% and 90-100%; a tile that comes into view while the others
  // are mid-wipe holds its front image until the next cycle starts.
  var WIPE_MS = 8000;
  var wipeIO = null;

  function startWipe(tile) {
    var now = (document.timeline && document.timeline.currentTime) || performance.now();
    var phase = now % WIPE_MS;
    var onFront = phase < WIPE_MS * 0.38 || phase >= WIPE_MS * 0.9;
    // Cycle start: the current one if the front image is showing, else the next.
    var start = now - phase + (onFront ? 0 : WIPE_MS);
    tile.classList.add('is-wiping');
    var anims = tile.getAnimations ? tile.getAnimations({ subtree: true }) : [];
    anims = anims.filter(function (a) {
      return a.animationName === 'yis-alt-wipe';
    });
    if (anims.length) {
      // Same start time on the shared timeline = exactly in step.
      anims.forEach(function (a) {
        a.startTime = start;
      });
    } else {
      tile.style.setProperty('--yis-alt-delay', Math.round(start - now) + 'ms');
    }
  }

  function initWipes() {
    var tiles = qsa('.yis-tile--alt:not(.is-wiping)');
    if (!tiles.length || reducedMotion()) return;
    if (!('IntersectionObserver' in window)) {
      tiles.forEach(startWipe);
      return;
    }
    if (!wipeIO) {
      wipeIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            wipeIO.unobserve(en.target);
            startWipe(en.target);
          });
        },
        { threshold: 0.35 }
      );
    }
    tiles.forEach(function (t) {
      if (t._yisWipe) return;
      t._yisWipe = true;
      wipeIO.observe(t);
    });
  }
  inits.push(initWipes);

  // Tiles added after load (e.g. product recommendations) are picked up as
  // they arrive; other changes (countdown ticks, the cart) are ignored.
  function watchWipes() {
    if (!('MutationObserver' in window) || !document.body || reducedMotion()) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.classList.contains('yis-tile--alt') || n.querySelector('.yis-tile--alt'))) {
            initWipes();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  inits.push(watchWipes);

  /* ========================= signup form ========================= */

  // Built-in signup (sections/yis-klaviyo-signup.liquid with a list ID):
  // subscribes the phone number (SMS marketing) and/or email to the Klaviyo
  // list through the public client API (CORS-enabled, needs only the public
  // site key). Replies 202 on success.

  // Phone as typed -> E.164 ("+15551234567"), or '' when it can't be one.
  // Without a leading + (or 00) the section's default country code is added.
  function toE164(raw, cc) {
    var s = String(raw || '').trim();
    var d = s.replace(/\D/g, '');
    if (!d) return '';
    if (s.charAt(0) !== '+') {
      if (d.indexOf('00') === 0) {
        d = d.slice(2);
      } else {
        var c = String(cc || '+1').replace(/\D/g, '') || '1';
        // US numbers typed with their leading 1 already carry the code.
        if (!(c === '1' && d.length === 11 && d.charAt(0) === '1')) d = c + d.replace(/^0+/, '');
      }
    }
    if (d.charAt(0) === '1' && d.length !== 11) return '';
    return /^[1-9]\d{7,14}$/.test(d) ? '+' + d : '';
  }

  function initSignup() {
    qsa('form[data-yis-signup]').forEach(function (form) {
      if (form._yisSignup) return;
      form._yisSignup = true;
      var emailIn = qs('input[type="email"]', form);
      var phoneIn = qs('input[type="tel"]', form);
      var inputs = [emailIn, phoneIn].filter(Boolean);
      var btn = qs('button[type="submit"]', form);
      var msg = qs('.yis-signup__msg', form);
      function say(text, state) {
        msg.textContent = text || '';
        form.setAttribute('data-state', state || '');
      }
      function bad(input, text) {
        input.setAttribute('aria-invalid', 'true');
        say(text, 'error');
        input.focus();
      }
      inputs.forEach(function (input) {
        input.addEventListener('input', function () {
          if (form.getAttribute('data-state') === 'error') say('', '');
          input.removeAttribute('aria-invalid');
        });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.getAttribute('data-state') === 'busy') return;
        var attrs = {};
        var subs = {};
        if (emailIn) {
          var email = emailIn.value.trim();
          if (!email || !emailIn.checkValidity() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            return bad(emailIn, form.getAttribute('data-invalid'));
          }
          attrs.email = email;
          subs.email = { marketing: { consent: 'SUBSCRIBED' } };
        }
        if (phoneIn) {
          var phone = toE164(phoneIn.value, form.getAttribute('data-cc'));
          if (!phone) return bad(phoneIn, form.getAttribute('data-invalid-phone'));
          attrs.phone_number = phone;
          subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
        }
        attrs.subscriptions = subs;
        say('', 'busy');
        btn.disabled = true;
        var source = form.getAttribute('data-source') === 'password' ? 'Password page' : 'Homepage';
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Thë Shop ' + source,
                profile: { data: { type: 'profile', attributes: attrs } },
              },
              relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } },
            },
          }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('klaviyo ' + r.status);
            say(form.getAttribute('data-ok'), 'done');
            inputs.forEach(function (input) {
              input.value = '';
            });
          })
          .catch(function (err) {
            if (window.console) console.error('[yis] signup', err);
            say(form.getAttribute('data-error'), 'error');
          })
          .then(function () {
            btn.disabled = false;
          });
      });
    });
  }
  inits.push(initSignup);

  /* ======================== lookbook tracking ======================== */
  // How the lookbook sells (docs/lookbook-tracking.md):
  // - Adds from it carry a hidden `_lookbook` line property (the photo
  //   handle) that lands on the order; cart, drawer and checkout hide `_`
  //   properties. A pin tap is remembered for 30 minutes, so adding that
  //   product on its own page (Buy it now too) is stamped as well.
  // - Custom events go out through Shopify.analytics.publish; the
  //   "Lookbook → GA4" custom pixel sends them to GA4. preview is 'yes' on
  //   any theme but the live one (dev server, theme editor, previews), so
  //   test traffic can be left out.
  var LB_STORE = 'yis-lookbook';
  var LB_TTL = 30 * 60 * 1000;
  var lb = { added: false, seen: {}, timer: 0, page: null };

  function lbTrack(name, data) {
    var t = window.Shopify && window.Shopify.theme;
    data.preview = (window.Shopify && window.Shopify.designMode) || !t || t.role !== 'main' ? 'yes' : 'no';
    // Previews keep a copy for checking in the console: YIS.lbLog.
    if (data.preview === 'yes') (YIS.lbLog = YIS.lbLog || []).push([name, data]);
    try {
      window.Shopify.analytics.publish(name, data);
    } catch (e) {}
  }

  function lbProduct(url) {
    var m = /\/products\/([^/?#]+)/.exec(url || '');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function lbLook(el) {
    var look = el && el.closest('[data-yis-look]');
    return look ? look.getAttribute('data-yis-look') : '';
  }

  function lbAmount(money) {
    return parseFloat(String(money || '').replace(/<[^>]*>/g, '').replace(/[^0-9.]/g, '')) || 0;
  }

  function lbCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  // Remembered pin taps: { <product handle>: { look, at, go } }; go = on the
  // way to the product page, which reports it once.
  function lbMemory() {
    var all = {};
    try {
      all = JSON.parse(localStorage.getItem(LB_STORE) || '{}') || {};
    } catch (e) {}
    var now = Date.now();
    Object.keys(all).forEach(function (k) {
      if (!all[k] || now - all[k].at > LB_TTL) delete all[k];
    });
    return all;
  }

  function lbSave(all) {
    try {
      localStorage.setItem(LB_STORE, JSON.stringify(all));
    } catch (e) {}
  }

  function lbRemember(product, look, at, go) {
    if (!product || !look) return;
    var all = lbMemory();
    all[product] = { look: look, at: at, go: !!go };
    lbSave(all);
  }

  function lbStamp(props, look) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      out[k] = props[k];
    });
    out._lookbook = look;
    return out;
  }

  // The modal's cart line, stamped with the photo. If that variant is
  // already in the cart, the add joins its line as it is instead (a stamped
  // copy would become a second line of the same item).
  function lbLine(item, v, look) {
    return fetch(routes.cart + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(
        function (cart) {
          var same = (cart.items || []).filter(function (i) {
            return i.variant_id === v.id;
          })[0];
          item.properties = same ? same.properties || {} : lbStamp(item.properties, look);
          return item;
        },
        function () {
          item.properties = lbStamp(item.properties, look);
          return item;
        }
      );
  }

  // Product page reached from a pin ("View full details", a new-tab click,
  // or the modal failing to load): stamp its add-to-cart forms. A variant
  // already in the cart gets its line's stamp (or none) so the add joins
  // that line (same second-line problem as above).
  function initLookbookProduct() {
    var product = lbProduct(window.location.pathname);
    if (!product || lb.page) return;
    var all = lbMemory();
    var hit = all[product];
    if (!hit) return;
    if (hit.go) {
      hit.go = false;
      lbSave(all);
      lbTrack('lookbook_product_opened', { look: hit.look, product: product, via: 'page' });
    }
    var stamps = [];
    qsa('form[action*="/cart/add"][data-product-form]').forEach(function (form) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_lookbook]';
      input.value = hit.look;
      form.appendChild(input);
      stamps.push({ form: form, input: input });
    });
    if (!stamps.length) return;
    var inCart = {};
    function loadCart() {
      fetch(routes.cart + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          inCart = {};
          (cart.items || []).forEach(function (i) {
            inCart[i.variant_id] = (i.properties && i.properties._lookbook) || '';
          });
        })
        .catch(function () {});
    }
    function variantOf(form) {
      var id = qs('[name="id"]', form);
      return id ? +id.value : 0;
    }
    // Runs before the theme's own submit and Buy it now click handlers.
    function sync() {
      stamps.forEach(function (s) {
        var v = variantOf(s.form);
        var there = Object.prototype.hasOwnProperty.call(inCart, v);
        s.input.value = there && inCart[v] ? inCart[v] : hit.look;
        s.input.disabled = there && !inCart[v];
      });
    }
    loadCart();
    document.addEventListener('submit', sync, true);
    document.addEventListener(
      'click',
      function (e) {
        if (e.target.closest && e.target.closest('form[data-product-form]')) sync();
      },
      true
    );
    lb.page = { look: hit.look, product: product, at: hit.at, stamps: stamps, reload: loadCart };
  }
  inits.push(initLookbookProduct);

  // theme.js reports a product page add through YIS.cart.added().
  function lbPageAdded() {
    var p = lb.page;
    if (!p) return;
    var s = p.stamps[0];
    var id = qs('[name="id"]', s.form);
    var qty = qs('[name="quantity"]', s.form);
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var variant = id ? +id.value : 0;
    var n = qty ? +qty.value || 1 : 1;
    var cents = 0;
    ((meta && meta.variants) || []).forEach(function (v) {
      if (v.id === variant) cents = v.price;
    });
    lbTrack('lookbook_added', {
      look: p.look,
      product: p.product,
      variant: String(variant),
      quantity: n,
      value: (cents / 100) * n,
      currency: lbCurrency(),
      via: 'page',
      stamped: s.input.disabled ? 'no' : 'yes',
      ms_to_add: Date.now() - p.at,
    });
    p.reload();
  }

  /* ========================== lookbook pins =========================== */
  // Pins render in hidden [data-yis-pins] holders (Lookbook and Lookbook pins
  // sections) and are copied onto their photo ([data-yis-look] = the pin's
  // photo handle). Copies are rebuilt from the holders every time, so a
  // section the theme editor re-renders never loses pins from another one.
  // Mouse: dots show while the photo is hovered (CSS), hovering a dot or its
  // card opens it. Touch: tap a photo to show its dots, tap a dot for its
  // card, tap the card to go to the product. One card open on the page.
  var lookPin = { open: null, downOpen: null, timer: 0, pointer: 'mouse', selected: '', quiet: false, bound: false };

  function closeLookPin() {
    var pin = lookPin.open;
    clearTimeout(lookPin.timer);
    if (!pin) return;
    pin.classList.remove('is-open');
    var btn = qs('.yis-pin__btn', pin);
    if (btn) btn.setAttribute('aria-expanded', 'false');
    lookPin.open = null;
  }

  // Card thumbnails are lazy (a page can hold hundreds of pins), but copies
  // made from the hidden holder don't reliably start lazy loading on their
  // own, so a photo's thumbnails load as soon as it's hovered or tapped,
  // before any of its cards opens.
  function warmLook(look) {
    if (!look || look._yisWarm) return;
    look._yisWarm = true;
    qsa('.yis-pin__th img', look).forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function openLookPin(pin) {
    clearTimeout(lookPin.timer);
    if (!pin || lookPin.open === pin) return;
    closeLookPin();
    warmLook(pin.parentNode);
    lookPin.open = pin;
    pin.classList.add('is-open');
    var btn = qs('.yis-pin__btn', pin);
    if (btn) btn.setAttribute('aria-expanded', 'true');
    // The card opens the quick view: fetch it now so the modal opens at once.
    var card = qs('.yis-pin__card', pin);
    if (card) qvFetch(card.getAttribute('href')).catch(function () {});
    // Counted once per pin per page view, and only if it stays open a
    // moment (a mouse passing over a dot opens it too).
    var id = pin.getAttribute('data-yis-block');
    clearTimeout(lb.timer);
    if (card && !lb.seen[id]) {
      lb.timer = setTimeout(function () {
        if (lookPin.open !== pin) return;
        lb.seen[id] = true;
        lbTrack('lookbook_pin_opened', {
          look: lbLook(pin),
          product: lbProduct(card.getAttribute('href')),
          after_add: lb.added ? 'yes' : 'no',
        });
      }, 500);
    }
  }

  // A pin card opens the product modal over the lookbook (the quick view the
  // Card + button uses); adding keeps the shopper here (see openModal opts).
  // If the quick view can't load, the card's link is followed instead.
  function openLookModal(card) {
    if (card.classList.contains('is-busy')) return;
    var root = card.closest('.yis-lookbook');
    var added = root ? decode(root.getAttribute('data-yis-added') || '') : '';
    var look = lbLook(card);
    var product = lbProduct(card.getAttribute('href'));
    var tapped = Date.now();
    var stamped = 'no';
    lbRemember(product, look, tapped, false);
    setBusy(card, true);
    qvFetch(card.getAttribute('href'))
      .then(function (d) {
        setBusy(card, false);
        lbTrack('lookbook_product_opened', { look: look, product: product, via: 'modal' });
        openModal(d, card, {
          stay: true,
          added: added,
          line: function (item, v) {
            return lbLine(item, v, look).then(function (line) {
              stamped = line.properties && line.properties._lookbook === look ? 'yes' : 'no';
              return line;
            });
          },
          onAdded: function (v, n) {
            lb.added = true;
            lbTrack('lookbook_added', {
              look: look,
              product: product,
              variant: String(v.id),
              quantity: n,
              value: lbAmount(v.price) * n,
              currency: lbCurrency(),
              via: 'modal',
              stamped: stamped,
              ms_to_add: Date.now() - tapped,
            });
          },
          onDetails: function () {
            lbRemember(product, look, tapped, true);
            lbTrack('lookbook_details_clicked', { look: look, product: product });
          },
        });
      })
      .catch(function () {
        setBusy(card, false);
        lbRemember(product, look, tapped, true);
        window.location.href = card.getAttribute('href');
      });
  }

  // Shows one photo's dots (touch) and hides every other photo's.
  function activateLook(look) {
    qsa('.yis-look.is-active').forEach(function (l) {
      if (l !== look) l.classList.remove('is-active');
    });
    if (look) {
      warmLook(look);
      look.classList.add('is-active');
    }
  }

  function lookPinCopy(id) {
    var found = null;
    if (!id) return null;
    qsa('[data-yis-look] > [data-yis-pin]').forEach(function (p) {
      if (p.getAttribute('data-yis-block') === id) found = p;
    });
    return found;
  }

  function buildLookPins() {
    var looks = {};
    qsa('[data-yis-look]').forEach(function (l) {
      looks[l.getAttribute('data-yis-look')] = l;
      l._yisWarm = false;
    });
    closeLookPin();
    qsa('[data-yis-look] > [data-yis-pin]').forEach(function (p) {
      p.parentNode.removeChild(p);
    });
    qsa('[data-yis-pins] [data-yis-pin]').forEach(function (src) {
      var look = looks[src.getAttribute('data-yis-pin-for')];
      if (look) look.appendChild(src.cloneNode(true));
    });
    // Theme editor: keep the selected pin open while its sliders re-render it.
    if (lookPin.selected) {
      var pin = lookPinCopy(lookPin.selected);
      if (pin) openLookPin(pin);
    }
  }

  function initLookPins() {
    if (!qs('[data-yis-look]')) return;
    buildLookPins();
    if (lookPin.bound) return;
    lookPin.bound = true;
    lbTrack('lookbook_viewed', {
      photos: qsa('[data-yis-look]').length,
      pins: qsa('[data-yis-look] > [data-yis-pin]').length,
    });

    function pinPart(el) {
      return el && el.closest ? el.closest('[data-yis-look] .yis-pin__btn, [data-yis-look] .yis-pin__card') : null;
    }

    document.addEventListener(
      'pointerdown',
      function (e) {
        lookPin.pointer = e.pointerType || 'mouse';
        // Which card was open when the finger went down: a tap focuses the
        // dot first on Android Chrome, and focusing opens its card.
        lookPin.downOpen = lookPin.open;
      },
      true
    );
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest) warmLook(e.target.closest('[data-yis-look]'));
      var part = pinPart(e.target);
      if (part) openLookPin(part.closest('[data-yis-pin]'));
    });
    document.addEventListener('pointerout', function (e) {
      if (e.pointerType !== 'mouse' || !lookPin.open) return;
      var from = pinPart(e.target);
      if (!from || from.closest('[data-yis-pin]') !== lookPin.open) return;
      var to = pinPart(e.relatedTarget);
      if (to && to.closest('[data-yis-pin]') === lookPin.open) return;
      // A short grace period lets the pointer cross from the dot to its card.
      clearTimeout(lookPin.timer);
      lookPin.timer = setTimeout(closeLookPin, 180);
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var btn = t.closest('[data-yis-look] .yis-pin__btn');
      if (btn) {
        e.preventDefault();
        var pin = btn.closest('[data-yis-pin]');
        activateLook(btn.closest('[data-yis-look]'));
        // A second tap on an open dot closes it; the tap that opened it
        // (through focus) doesn't.
        var wasOpen = lookPin.downOpen === pin;
        lookPin.downOpen = null;
        if (wasOpen && lookPin.open === pin && lookPin.pointer !== 'mouse') closeLookPin();
        else openLookPin(pin);
        return;
      }
      var card = t.closest('[data-yis-look] .yis-pin__card');
      if (card) {
        // New tab / window clicks keep the plain link.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) {
          lbRemember(lbProduct(card.getAttribute('href')), lbLook(card), Date.now(), true);
          return;
        }
        e.preventDefault();
        openLookModal(card);
        return;
      }
      var look = t.closest('[data-yis-look]');
      if (look) {
        if (lookPin.pointer === 'mouse') return;
        if (lookPin.open && lookPin.open.parentNode === look) {
          closeLookPin();
          return;
        }
        var show = !look.classList.contains('is-active');
        closeLookPin();
        activateLook(show ? look : null);
        if (!show) look.classList.remove('is-active');
        return;
      }
      if (lookPin.open || qs('.yis-look.is-active')) {
        closeLookPin();
        activateLook(null);
      }
    });
    document.addEventListener('focusin', function (e) {
      if (lookPin.quiet) return;
      var btn = e.target.closest && e.target.closest('[data-yis-look] .yis-pin__btn');
      if (btn) openLookPin(btn.closest('[data-yis-pin]'));
    });
    document.addEventListener('focusout', function (e) {
      var pin = lookPin.open;
      if (!pin || !pin.contains(e.target) || !e.relatedTarget) return;
      if (!pin.contains(e.relatedTarget)) closeLookPin();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !lookPin.open) return;
      var btn = qs('.yis-pin__btn', lookPin.open);
      closeLookPin();
      // Back to the dot without reopening its card.
      if (btn) {
        lookPin.quiet = true;
        btn.focus();
        lookPin.quiet = false;
      }
    });
  }
  inits.push(initLookPins);

  /* ============================== boot ============================== */

  function run(list) {
    list.forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        // A broken module must never take the rest of the page down.
        if (window.console) console.error('[yis]', e);
      }
    });
  }

  // Modules that bind to elements inside sections. Each skips elements it
  // has already set up, so they can run again after the theme editor
  // re-renders a section. The rest (drawers, cart, keys, card +)
  // listen on the document and run once.
  var rebind = [initTrailers, initSearchBar, initSuggest, initCarousels, initRows, initOptionButtons, initQtySteppers, initGallery, initWipes, initSignup, initLookPins];

  function boot() {
    // Decorative loops that began before this script ran (see reduced motion).
    if (reducedMotion()) {
      qsa('video[loop][muted], video[loop][autoplay]').forEach(function (v) {
        if (!v.controls && !v.paused) v.pause();
      });
    }
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
    run(inits);
  }

  // Theme editor. Countdowns pick up new markup on their own (every tick).
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      // A re-rendered header or cart drawer comes back closed.
      if (openDrawer) closeDrawers(false);
      // After theme.js has re-initialised its own sections (product forms).
      setTimeout(function () {
        run(rebind);
      }, 0);
    });
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(function () {
        run([initRows, initLookPins]);
      }, 0);
    });
    // Selecting a hero slide block shows that slide and holds it; selecting a
    // lookbook pin opens it (and keeps it open while its sliders re-render).
    document.addEventListener('shopify:block:select', function (e) {
      var hc = e.target.closest && e.target.closest('[data-yis-hc]');
      if (hc && hc._yis) hc._yis.show(e.target);
      var id = e.target.getAttribute && e.target.getAttribute('data-yis-block');
      var pin = id && lookPinCopy(id);
      if (pin) {
        lookPin.selected = id;
        activateLook(pin.parentNode);
        openLookPin(pin);
        pin.parentNode.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var hc = e.target.closest && e.target.closest('[data-yis-hc]');
      if (hc && hc._yis) hc._yis.release();
      if (e.target.getAttribute && e.target.getAttribute('data-yis-block')) {
        lookPin.selected = '';
        closeLookPin();
      }
    });
  }

  YIS.reducedMotion = reducedMotion;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
